export default __webpack_public_path__ + "static/media/wings2.62913b83.svg";